/**
 * Offset mínimo de elevação (px) — referência de design.
 * Sombras completas MUI: `theme.shadows`; ajustar quando a matriz oficial existir.
 */
export const elevationOffsetPx = 4;
